import {CSSProperties} from 'aphrodite';

export const firstColumn: CSSProperties = {
  display: 'inline-block',
  width: 250,
};
